export function getUrl () {
  return 'https://www.docter.com.cn/apidoctor/'
}